(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["al-countdown-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-al-halloween-sale]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const end = Date.parse(root.dataset.deadline);
      const start = Date.parse('2026-10-31T00:00:00+01:00');
      const fields = ['d', 'h', 'm', 's'].map(key => root.querySelector('[data-' + key + ']'));
      let interval;
      const tick = () => {
        const now = Date.now();
        if (!root.isConnected || !Number.isFinite(end) || now < start || now >= end) {
          root.hidden = true;
          clearInterval(interval);
          return false;
        }
        const left = Math.max(0, Math.ceil((end - now) / 1000));
        const values = [Math.floor(left / 86400), Math.floor(left / 3600) % 24, Math.floor(left / 60) % 60, left % 60];
        fields.forEach((node, i) => { node.textContent = String(values[i]).padStart(2, '0'); });
        return true;
      };
      if (tick()) interval = setInterval(tick, 1000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
